import { Heading, Subheading } from "../../../../design/heading";
import { Divider } from "../../../../design/divider";
import EditProfileButton from "./components/EditProfileButton";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "../../../../design/description-list";
import { useUser } from "../../../../contexts/UserContext";
import Breadcrumbs from "../../../../components/Breadcrumbs";

export default function UserInformation() {
  const { currentUser } = useUser();
  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Settings", href: "/settings" },
          { label: "Profile", href: "/settings/profile" },
        ]}
      />
      <Heading>Profile</Heading>

      <div className="flex items-end justify-between gap-4">
        <Subheading>User</Subheading>
        <EditProfileButton />
      </div>

      <Divider className="my-4" />

      <DescriptionList>
        <DescriptionTerm>Name</DescriptionTerm>
        <DescriptionDetails>
          {currentUser?.firstName} {currentUser?.lastName}
        </DescriptionDetails>
        <DescriptionTerm>Email</DescriptionTerm>
        <DescriptionDetails>{currentUser?.email}</DescriptionDetails>
        <DescriptionTerm>Phone</DescriptionTerm>
        <DescriptionDetails>{currentUser?.phoneNumber}</DescriptionDetails>
      </DescriptionList>
    </div>
  );
}
